import { render, staticRenderFns } from "./AdInsightsView.vue?vue&type=template&id=ca2963d0&scoped=true"
import script from "./AdInsightsView.vue?vue&type=script&lang=js"
export * from "./AdInsightsView.vue?vue&type=script&lang=js"
import style0 from "./AdInsightsView.vue?vue&type=style&index=0&id=ca2963d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2963d0",
  null
  
)

export default component.exports